import axios from 'axios';
import { ApiLink } from '../APILink/ApiLink';
import { errorAlert } from '../Components/Alerts';

const getCompanyPack = async (headers) => {
    try {
        const response = await axios.get(ApiLink.API_URL + 'PackContoller/getCompanyPack', { headers });
        // console.log(response.data);

        return response.data[0].Pack || null; // Kthe rolin ose null nëse nuk ka
    } catch (error) {
        errorAlert("Gabim te roli");
        return null; // Kthe null në rast gabimi
    }
};

export default getCompanyPack;
